module.exports = __webpack_public_path__ + "img/40_65.c9f8f279.png";